import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { patchMe } from '../../api/auth';
import PageHeader from '../../components/common/PageHeader';

export default function Perfil() {
  const { user, updateUser } = useAuth();

  /* ── Dados pessoais ── */
  const [nome, setNome]           = useState(user?.nome || '');
  const [salvandoNome, setSalvandoNome] = useState(false);
  const [erroNome, setErroNome]   = useState('');
  const [okNome, setOkNome]       = useState('');

  /* ── Senha ── */
  const [expandirSenha, setExpandirSenha] = useState(false);
  const [senhaAtual, setSenhaAtual]       = useState('');
  const [novaSenha, setNovaSenha]         = useState('');
  const [confirmar, setConfirmar]         = useState('');
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [erroSenha, setErroSenha]         = useState('');
  const [okSenha, setOkSenha]             = useState('');

  const salvarNome = async (e) => {
    e.preventDefault();
    setErroNome(''); setOkNome('');
    setSalvandoNome(true);
    try {
      const { data } = await patchMe({ nome: nome.trim() });
      updateUser({ nome: data.nome });
      setOkNome('Nome atualizado com sucesso!');
    } catch (err) {
      const d = err.response?.data?.detail;
      setErroNome(typeof d === 'string' ? d : 'Erro ao salvar. Tente novamente.');
    } finally {
      setSalvandoNome(false);
    }
  };

  const salvarSenha = async (e) => {
    e.preventDefault();
    setErroSenha(''); setOkSenha('');
    if (novaSenha !== confirmar) {
      setErroSenha('As senhas não coincidem.');
      return;
    }
    setSalvandoSenha(true);
    try {
      await patchMe({ senha_atual: senhaAtual, nova_senha: novaSenha });
      setOkSenha('Senha alterada com sucesso!');
      setSenhaAtual(''); setNovaSenha(''); setConfirmar('');
      setExpandirSenha(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      setErroSenha(typeof d === 'string' ? d : 'Erro ao alterar a senha. Tente novamente.');
    } finally {
      setSalvandoSenha(false);
    }
  };

  const toggleSenha = () => {
    setExpandirSenha(s => !s);
    setErroSenha(''); setOkSenha('');
    setSenhaAtual(''); setNovaSenha(''); setConfirmar('');
  };

  return (
    <div>
      <PageHeader titulo="Meu Perfil" subtitulo="Gerencie seus dados de acesso" />

      <div style={{ maxWidth: 500 }}>

        {/* ── Dados pessoais ── */}
        <div className="card mb-4">
          <div className="card-body" style={{ padding: '24px 28px' }}>
            <h6 className="fw-bold mb-4" style={{ color: 'var(--cjc-primary)', fontSize: 14, letterSpacing: '.3px', textTransform: 'uppercase' }}>
              Dados pessoais
            </h6>

            <div className="mb-3">
              <label className="form-label fw-semibold">E-mail</label>
              <input className="form-control" value={user?.email || ''} disabled />
              <div className="form-text">O e-mail de acesso não pode ser alterado.</div>
            </div>

            <form onSubmit={salvarNome}>
              {erroNome && <div className="alert alert-danger py-2 mb-3">{erroNome}</div>}
              {okNome   && <div className="alert alert-success py-2 mb-3">{okNome}</div>}

              <div className="mb-4">
                <label className="form-label fw-semibold">Nome</label>
                <input
                  className="form-control"
                  value={nome}
                  onChange={e => { setNome(e.target.value); setOkNome(''); }}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary btn-sm" disabled={salvandoNome}>
                {salvandoNome ? <span className="spinner-border spinner-border-sm me-1" /> : null}
                Salvar nome
              </button>
            </form>
          </div>
        </div>

        {/* ── Senha ── */}
        <div className="card">
          <div className="card-body" style={{ padding: '24px 28px' }}>
            <div className="d-flex justify-content-between align-items-center mb-1">
              <h6 className="fw-bold mb-0" style={{ color: 'var(--cjc-primary)', fontSize: 14, letterSpacing: '.3px', textTransform: 'uppercase' }}>
                Senha de acesso
              </h6>
              <button
                type="button"
                className={`btn btn-sm ${expandirSenha ? 'btn-outline-secondary' : 'btn-outline-primary'}`}
                onClick={toggleSenha}
              >
                {expandirSenha ? 'Cancelar' : 'Alterar senha'}
              </button>
            </div>

            {!expandirSenha && (
              <p className="text-muted mb-0 mt-2" style={{ fontSize: 13 }}>
                Sua senha está configurada. Clique em "Alterar senha" para redefinir.
              </p>
            )}

            {expandirSenha && (
              <form onSubmit={salvarSenha} className="mt-4">
                {erroSenha && <div className="alert alert-danger py-2 mb-3">{erroSenha}</div>}
                {okSenha   && <div className="alert alert-success py-2 mb-3">{okSenha}</div>}

                <div className="mb-3">
                  <label className="form-label fw-semibold">Senha atual</label>
                  <input
                    type="password"
                    className="form-control"
                    value={senhaAtual}
                    onChange={e => setSenhaAtual(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-semibold">Nova senha</label>
                  <input
                    type="password"
                    className="form-control"
                    value={novaSenha}
                    onChange={e => setNovaSenha(e.target.value)}
                    autoComplete="new-password"
                    minLength={6}
                    required
                  />
                  <div className="form-text">Mínimo 6 caracteres.</div>
                </div>
                <div className="mb-4">
                  <label className="form-label fw-semibold">Confirmar nova senha</label>
                  <input
                    type="password"
                    className="form-control"
                    value={confirmar}
                    onChange={e => setConfirmar(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary btn-sm" disabled={salvandoSenha}>
                  {salvandoSenha ? <span className="spinner-border spinner-border-sm me-1" /> : null}
                  Salvar nova senha
                </button>
              </form>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}
